export default "__VITE_ASSET__36fbce76__"